import { SignOutParams } from 'next-auth/react';
import { useCallback } from 'react';
import { useExperiments } from 'src/services/experiments/ContextProviders/ExperimentProvider';
import { handleSessionStart } from './utils/handleSessionStart';
import { handleSessionTermination } from './utils/handleSessionTermination';
import { useZillowSession } from './useZillowSession';
import { ZillowSignInOptions } from './utils/zillowSignIn/zillowSignIn';

export type SessionTerminationConfig = SignOutParams & {
    errorMessage?: string;
};

export const useSessionManagement = () => {
    const { experiments } = useExperiments();
    const sessionHookResult = useZillowSession();
    const startSession = useCallback(
        (
            justification: string,
            signInOptions: ZillowSignInOptions = {},
            authorizationParams: Record<string, string> = {}
        ) => {
            handleSessionStart(justification, experiments, signInOptions, authorizationParams);
        },
        [experiments]
    );
    const endSession = useCallback(
        (justification: string, { errorMessage, ...config }: SessionTerminationConfig = {}) => {
            handleSessionTermination(justification, errorMessage, config);
        },
        []
    );

    return {
        startSession,
        endSession,
        ...sessionHookResult,
    };
};
